import { observable, action, runInAction } from 'mobx'
import Api from '@api/xiu_yan/jukeTreasureApi'

class Store {
  @observable list = []
  @observable total = 1
  @observable
  pagination = {
    current: 1,
    pageSize: 10,
    total: 1
  }
  @action
  getList = async page => {
    const { pagination } = this
    let params = {
      per_page: 10,
      page: page ? page : pagination.current
    }
    let {
      data: { list, total_count }
    } = await Api.already(params)
    runInAction(() => {
      this.list = list
      this.pagination.total = +total_count
    })
  }

  @action
  setPage = page => {
    this.pagination.current = page.current
    this.getList(page.current)
  }
}
export default new Store()
